import * as React from "react";
const SvgB1Robot24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 21,
        fill: "black",
        viewBox: "0 0 24 21"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1.22 0h21.56L24 4.877V16.5h-.005a4 4 0 0 1-5.518 3.5H5.523a4 4 0 0 1-5.518-3.5H0V4.877L1.22 0Zm15.158 18A4 4 0 0 1 22 12.835V6H2v6.835A4 4 0 0 1 7.622 18h8.756ZM2.281 4h19.438l-.5-2H2.781l-.5 2ZM4 14.3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm14 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgB1Robot24Px;
